module.exports = __webpack_public_path__ + "static/media/sci.8c6837be.svg";